import { Delete, ExitToApp } from '@mui/icons-material';
import { Fab, Tooltip } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { ConversationType } from '../../models/conversation';
import { ConversationRole } from '../../models/member';
import { useDeleteConversation } from '../../queries/conversation.mutations';
import { useUserPermissions } from '../../queries/permission.queries';

interface ConversationDeleteFabProps {
  conversationId: string;
  conversationType: ConversationType;
}

export const ConversationDeleteFab: FC<ConversationDeleteFabProps> = ({ conversationId, conversationType }) => {
  const { t } = useTranslation();
  const { xoa, isPending } = useDeleteConversation();
  const { data } = useUserPermissions(conversationId);

  if (data?.role !== ConversationRole.OWNER) return;
  return (
    <Tooltip
      title={
        conversationType === 'DIRECT'
          ? t('conversations.aside.leaveConversation')
          : t('conversations.aside.deleteConversation')
      }
      placement='left'
    >
      <Fab
        aria-label={t('conversations.aside.deleteAria')}
        color='error'
        size='small'
        disabled={isPending}
        onClick={(e) => {
          e.preventDefault();
          xoa(conversationId, conversationType);
        }}
      >
        {isPending ? (
          <div className='mex:loading-spinner mex:size-5 mex:border-2 mex:border-white mex:border-t-transparent' />
        ) : conversationType === 'DIRECT' ? (
          <ExitToApp />
        ) : (
          <Delete />
        )}
      </Fab>
    </Tooltip>
  );
};

export default ConversationDeleteFab;
